import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    scrollContentContainer: {
        justifyContent: "center",
        flexGrow: 1
    },
    container: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    backButtonContainer: {
        alignItems: "center"
    },
    subtitle: {
        textAlign: "center"
    },
    formContainer: {
        maxWidth: 400,
        width: "100%"
    }
});

export default stylesheet;
